import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Grid, Card, TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import DateSelect from '../../../components/DateSelect';
import Button from '../../../components/Button';
import BlogEditModal from '../../../components/BlogEditModal';

import * as api from '../../../services/api/admin';

function BlogContent(props) {
  const {
    classes: {
      input,
      cards,
      contentCard,
      paragraph,
      heading,
      secondaryHeading,
      subParagraph,
    },
  } = props;

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [blogContents, setBlogContents] = useState([]);
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [headline, setHeadline] = useState('');
  const [category, setCategory] = useState([]);
  const [date, setDate] = useState('');
  const [linkToImg, setLinkToImg] = useState('');
  const [content, setContent] = useState('');
  const [imgDescription, setImgDescription] = useState('');
  const [blogUrl, setBlogUrl] = useState('');
  const [externalUrl, setExternalUrl] = useState('');
  const [openEditModal, setOpenEditModal] = useState('');

  const sanitizeTrailingSlash = url => {
    if (url[url.length - 1] === '/') {
      return `/blog/${url.slice(0, url.length - 1).replace(/\W+/g, '-')}`;
    } else {
      return `/blog/${url.replace(/\W+/g, '-')}`;
    }
  };

  useEffect(() => {
    (async () => {
      const contents = await api.fetchBlogContents();
      setBlogContents(contents);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const contents = await api.fetchBlogContents();
      setBlogContents(contents);
    })();
  }, [openEditModal]);

  const createBlogContent = async item => {
    const contentDetails = {
      ...item,
      blogUrl: sanitizeTrailingSlash(item.title),
    };
    await api.createBlogContent(contentDetails);
    const contents = await api.fetchBlogContents();
    setBlogContents(contents);
    setTitle('');
    setAuthor('');
    setHeadline('');
    setCategory('');
    setDate('');
    setLinkToImg('');
    setContent('');
    setImgDescription('');
    setExternalUrl('');
  };

  const onDelete = async id => {
    try {
      await api.deleteBlogContent(id);
    } catch (err) {
      console.log(err);
    }
    const contents = await api.fetchBlogContents();
    setBlogContents(contents);
    setOpenEditModal('');
  };
  return (
    <>
      <Grid container alignItems="center">
        <Grid item xs={11}>
          <h2>Insert New Blog Content</h2>
        </Grid>
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="title"
          value={title}
          className={input}
          onChange={event => {
            setTitle(event.target.value);
          }}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Title"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="author"
          value={author}
          className={input}
          onChange={event => {
            setAuthor(event.target.value);
          }}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Author"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="headline"
          value={headline}
          className={input}
          onChange={event => {
            setHeadline(event.target.value);
          }}
          InputProps={{ whiteSpace: 'pre-line' }}
          multiline
          rows="2"
          helperText="Headline"
        />
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="category"
          value={category}
          className={input}
          onChange={event => {
            setCategory(event.target.value);
          }}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Category"
        />

        <DateSelect
          label="Date Published"
          disableFuture
          fullWidth
          format="MM/DD/YYYY"
          placeholder="Date originally publihed MM/DD/YYYY ex. 01/01/2001"
          variant="outlined"
          value={new Date(date)}
          onChange={date => {
            setDate(moment(date).format('MM/DD/YYYY'));
          }}
        />
        <TextField
          variant="outlined"
          fullWidth
          name="linkToImg"
          value={linkToImg}
          className={input}
          onChange={event => {
            setLinkToImg(event.target.value);
          }}
          multiline
          rows="1"
          helperText="Image Url link."
        />
        <TextField
          variant="outlined"
          fullWidth
          name="imgDescription"
          value={imgDescription}
          className={input}
          onChange={event => {
            setImgDescription(event.target.value);
          }}
          multiline
          rows="1"
          helperText="Img description."
        />
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="content"
          value={content}
          className={input}
          onChange={event => {
            setContent(event.target.value);
          }}
          multiline
          InputProps={{ whiteSpace: 'pre-line' }}
          rows="4"
          helperText="Content goes here"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="externalUrl"
          value={externalUrl}
          className={input}
          onChange={event => {
            setExternalUrl(event.target.value);
          }}
          multiline
          InputProps={{ whiteSpace: 'pre-line' }}
          rows="1"
          helperText="Video URL goes here. Make sure you are getting the embedded link! They are often under *share*... https://www.youtube.com/embed/DwjMCtjxtTg"
        />
      </Grid>
      <Button
        onClickSuccessSnackbar="Content was sucessfully submitted."
        onClickFailSnackbar="Content could not be submitted"
        color="primary"
        variant="contained"
        onClick={() =>
          createBlogContent({
            title,
            author,
            headline,
            category,
            date,
            linkToImg,
            content,
            imgDescription,
            blogUrl,
            externalUrl,
          })
        }
      >
        Submit
      </Button>

      <Grid items className={cards}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={heading}>Title</Typography>

          <Typography className={heading}>Author</Typography>

          <Typography className={heading}>Date published</Typography>
        </AccordionSummary>
        {blogContents
          ? blogContents
              .sort((a, b) => new Date(a.date) - new Date(b.date))
              .map((content, i) => {
                return (
                  <Accordion
                    expanded={expanded === `panel${i}`}
                    onChange={handleChange(`panel${i}`)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography className={heading}>
                        {content.title}
                      </Typography>

                      <Typography className={heading}>
                        {content.author}
                      </Typography>

                      <Typography className={secondaryHeading}>
                        {moment.utc(content.date).format('MM/DD/YYYY')}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container className={contentCard}>
                        <Grid item xs={3}>
                          <img
                            src={content.linkToImg}
                            width="300"
                            height="300"
                            alt={content.imgDescription}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <Typography variant="subtitle">
                            {content.headline}
                          </Typography>
                          <Typography
                            gutterBottom="true"
                            variant="h6"
                            className={paragraph}
                          >
                            {content.content.split('\n').map(paragraph => (
                              <Typography gutterBottom="true">
                                {paragraph}
                              </Typography>
                            ))}
                          </Typography>
                          <Typography varaiant="h6" className={subParagraph}>
                            Image description: {content.imgDescription}
                          </Typography>

                          <Typography varaiant="h6" className={subParagraph}>
                            URL: https://www.qwell.com{content.blogUrl}
                          </Typography>
                          <Typography>
                            external Url:{' '}
                            <iframe
                              src={content.externalUrl}
                              width="800"
                              height="600"
                              frameBorder="0"
                              allowFullScreen="allowFullScreen"
                            />
                          </Typography>
                          <Button
                            onClick={() => {
                              setOpenEditModal(content.id);
                            }}
                          >
                            {' '}
                            Edit
                          </Button>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })
          : null}
      </Grid>
      <BlogEditModal
        onDelete={onDelete}
        openEditModal={openEditModal}
        onClose={() => {
          setOpenEditModal('');
        }}
      />
    </>
  );
}

const styles = theme => ({
  contentCard: {
    margin: '2em',
    padding: '1em',
    display: 'flex',
    justify: 'center',
  },
  card: {
    margin: '1em',
  },
  cards: {
    padding: '1em',
    margin: '1.5em',
  },
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  thirdHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    display: 'flex',
    justifyContent: 'right',
  },

  paragraph: {
    padding: '1.5em',
  },
  subParagraph: {
    padding: '0.5em',
  },
});

export default withStyles(styles)(BlogContent);
